import { render, staticRenderFns } from "./IngredientsForm.vue?vue&type=template&id=32eaa97e&"
import script from "./IngredientsForm.vue?vue&type=script&lang=ts&"
export * from "./IngredientsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports